import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './ClampedText.css';

// Text shown in at most `lines` lines, with "…" when it is longer. When it is cut off, hovering shows a card with the full text.
// A short text that fits shows no card.
const ClampedText = ({ text, lines = 3, className = '' }) => {
    const ref = useRef(null);
    const [cut, setCut] = useState(false);
    const [tip, setTip] = useState(null);

    useLayoutEffect(() => {
        const el = ref.current;
        if (el) setCut(el.scrollHeight > el.clientHeight + 1);
    }, [text, lines]);

    const show = () => {
        if (!cut || !ref.current) return;
        const rect = ref.current.getBoundingClientRect();
        const below = rect.top < window.innerHeight / 2;
        setTip({ below, left: Math.min(Math.max(12, rect.left), window.innerWidth - 432), top: below ? rect.bottom + 8 : rect.top - 8 });
    };

    if (!text) return <span className={className}>—</span>;
    return (
        <>
            <span ref={ref} className={`clamped-text ${className}`} style={{ WebkitLineClamp: lines }} tabIndex={cut ? 0 : undefined}
                onMouseEnter={show} onMouseLeave={() => setTip(null)} onFocus={show} onBlur={() => setTip(null)}>
                {text}
            </span>
            {tip && createPortal(
                <div className="clamped-tip" role="tooltip" style={{ left: tip.left, top: tip.top, transform: tip.below ? 'none' : 'translateY(-100%)' }}>
                    {text}
                </div>,
                document.body,
            )}
        </>
    );
};

export default ClampedText;
